import { cn } from '@/utils/tailwind.util';
const SkeletonBlock = ({
  className
}: {
  className?: string;
}) => <div className={cn('animate-pulse rounded-sm bg-opacity-black-1', className)} data-sentry-component="SkeletonBlock" data-sentry-source-file="QuizBankProblemCardSkeleton.tsx" />;

/** 문제 카드 스켈레톤. 블록 구성이 실제 카드와 같아야 채워질 때 레이아웃이 튀지 않는다. */
export const QuizBankProblemCardSkeleton = () => <div className="flex w-full flex-shrink-0 flex-col overflow-hidden rounded-md border border-alternative bg-default" data-sentry-component="QuizBankProblemCardSkeleton" data-sentry-source-file="QuizBankProblemCardSkeleton.tsx">
    {/* QuizCard.Header 와 같은 상단 여백 */}
    <div className="min-h-[28px] w-full px-lg" />

    {/* 배지 줄 + 문제 텍스트 2줄 + 보기 4줄 */}
    <div className="flex w-full flex-col gap-md px-lg pb-lg pt-0">
      <div className="flex items-center justify-between gap-sm">
        <SkeletonBlock className="h-[30px] w-[64px]" data-sentry-element="SkeletonBlock" data-sentry-source-file="QuizBankProblemCardSkeleton.tsx" />
        <SkeletonBlock className="size-[20px] !rounded-xs" data-sentry-element="SkeletonBlock" data-sentry-source-file="QuizBankProblemCardSkeleton.tsx" />
      </div>

      <div className="flex flex-col gap-2xs">
        <SkeletonBlock className="h-[24px] w-[78%]" data-sentry-element="SkeletonBlock" data-sentry-source-file="QuizBankProblemCardSkeleton.tsx" />
        <SkeletonBlock className="h-[24px] w-[46%]" data-sentry-element="SkeletonBlock" data-sentry-source-file="QuizBankProblemCardSkeleton.tsx" />
      </div>

      <div className="flex flex-col gap-sm">
        {Array.from({
        length: 4
      }).map((_, index) => <div key={index} className="flex items-center gap-xs">
            <SkeletonBlock className="size-[30px] shrink-0 !rounded-full" />
            <SkeletonBlock className="h-[20px] w-[120px]" />
          </div>)}
      </div>
    </div>

    {/* 푸터 — 작성자 | 영역 | 단원 | 성취기준 */}
    <div className="flex w-full items-center gap-xs border-t border-assistive px-md py-[14px]">
      <SkeletonBlock className="h-[18px] w-[104px]" data-sentry-element="SkeletonBlock" data-sentry-source-file="QuizBankProblemCardSkeleton.tsx" />
      <SkeletonBlock className="h-[18px] w-[56px]" data-sentry-element="SkeletonBlock" data-sentry-source-file="QuizBankProblemCardSkeleton.tsx" />
      <SkeletonBlock className="h-[18px] w-[40px]" data-sentry-element="SkeletonBlock" data-sentry-source-file="QuizBankProblemCardSkeleton.tsx" />
      <SkeletonBlock className="h-[18px] w-[64px]" data-sentry-element="SkeletonBlock" data-sentry-source-file="QuizBankProblemCardSkeleton.tsx" />
    </div>
  </div>;